import { render, staticRenderFns } from "./goodsIncome.vue?vue&type=template&id=99a639ce&scoped=true&"
import script from "./goodsIncome.vue?vue&type=script&lang=js&"
export * from "./goodsIncome.vue?vue&type=script&lang=js&"
import style0 from "./goodsIncome.vue?vue&type=style&index=0&id=99a639ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a639ce",
  null
  
)

export default component.exports